
export const RoleActionTypes = {
   // SET_ROLE_DATA: 'SET_ROLE_DATA',
    SET_ROLE_DATA: 'SET_ROLE_DATA',
    RESET: "RESET"
  };
  